import Script from "next/script";

import MainTemplate from "@/components/Templates/MainTemplate";

import BootCampLandingPage from "@/containers/BootCampPages/BootCampLandingPage";

import { generateQueryArgumentsServerSide, renderMetaData } from "@/utils";

import * as actions from "@/redux/BootCampReducer";
import { wrapper } from "@/redux/Store";

interface BootCampProps {
  data: any;
}

const BootCamp: React.FC<BootCampProps> = ({ data }) => {
  const meta = {
    title: data?.meta.title || data?.title,
    description: data?.meta.description || data?.description,
    pageTitle: data?.meta.pageTitle,
    pageDescription: data?.meta.pageDescription,
    thumbnail: data?.meta?.image,
  };

  const metaTags = renderMetaData(meta);

  return (
    <>
      {metaTags}
      <Script defer={true} src="https://tally.so/widgets/embed.js" />
      <main id="bootcamp-page">
        <MainTemplate hideRibbon>
          <BootCampLandingPage />
        </MainTemplate>
      </main>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query }) => {
      let slug =
        typeof query?.slug === "string" ? query?.slug : query?.slug?.[0] || "";

      let bootcampType =
        typeof query?.bootcampType === "string"
          ? query?.bootcampType
          : query?.bootcampType?.[0] || "";

      const bootCampData = await store.dispatch(
        actions.getBootCampPageData({
          bootcampType,
          pageSlug: slug,
        })
      );

      const utmSource = query?.utm_source;

      if (slug === "1-on-1-yoga-trial") {
        await store.dispatch(actions.getOneOnOneYogaSlots({}));
      }
      if (slug === "online-yoga-class") {
        await store.dispatch(actions.getOneOnOneYogaSlots({}));
      }

      if (slug === "indians-living-abroad" && !utmSource) {
        const _query = { ...query, utm_source: "ila" };

        delete _query.bootcampType;
        delete _query.slug;

        const queryString = generateQueryArgumentsServerSide(_query);

        return {
          redirect: {
            destination: `/plans/${bootcampType}/${slug}/${queryString}`,
            permanent: true,
          },
        };
      } else if (bootCampData?.payload) {
        return {
          props: {
            data: bootCampData?.payload,
          },
        };
      } else {
        return {
          redirect: {
            destination: '/', 
            permanent: true      },
        }
        // return {
        //   notFound: true,
        // };
      }
    }
);

export default BootCamp;
